import React, { useLayoutEffect, useRef, useState } from "react";
import GUI, { IGUIProps } from "../GUI";

export type TMeasureProps = IGUIProps & {
    id?:string
    contentClass?:string
    overflowContent?:React.ReactNode
    children:React.ReactNode
    onMeasure?:(overflow:boolean) => void
}
export default function Measure(props:TMeasureProps){
    const [overflow,setOverlow] = useState<boolean>(false)
    const container = useRef<HTMLDivElement|null>(null)
    const content = useRef<HTMLDivElement|null>(null)

    useLayoutEffect(() => {
        if (!container.current || !content.current) return
        const observer = new ResizeObserver(() => {
            if (!container.current || !content.current) return
            const overflow = content.current.clientWidth>container.current.clientWidth
            props.onMeasure?.(overflow)
            setOverlow(overflow)
        })
        observer.observe(container.current)
        return () => { observer.disconnect() }
    }, [props.children])

    const id = props.id ? {id:props.id} : {}
    const visibility : React.CSSProperties = overflow && props.overflowContent ? {visibility:"hidden"} : {}
    return <div className={GUI.joinClass("measure flex", props.className, overflow ? "overflow" : "")} ref={container} {...id} style={{overflow:"hidden"}}>
        {overflow ? props.overflowContent : null}
        <div ref={content} className={GUI.joinClass("measure-content", props.contentClass)} style={{width:"max-content",...visibility}}>{props.children}</div>
    </div>
}